(function () {
  var cache = new Map();
  var queue = [];
  var active = 0;
  var scheduled = false;
  function key(url, options) {
    var absolute = new URL(url, document.baseURI).href;
    return absolute + (options && options.srcset ? '|' + options.srcset + '|' + options.sizes + '|' + window.innerWidth + '|' + window.devicePixelRatio : '');
  }
  function load(url, options) {
    if (!url) return Promise.resolve();
    options = options || {};
    var id = key(url, options);
    var record = cache.get(id);
    if (record && record.ready && !record.image.complete) {cache.delete(id); record = null;}
    if (record) {
      if (options.priority !== 'low') record.image.fetchPriority = 'high';
      return record.promise;
    }
    var image = new Image();
    record = {image: image, ready: false};
    image.decoding = 'async';
    image.fetchPriority = options.priority || 'auto';
    record.promise = new Promise(function (resolve, reject) {
      image.onload = function () {
        var decoded = image.decode ? image.decode().catch(function () {}) : Promise.resolve();
        decoded.then(function () {record.ready = true; resolve();});
      };
      image.onerror = function () {if (cache.get(id) === record) cache.delete(id); reject(new Error('Image unavailable'));};
      if (options.sizes) image.sizes = options.sizes;
      if (options.srcset) image.srcset = options.srcset;
      image.src = url;
    });
    cache.set(id, record);
    if (cache.size > 48) cache.delete(cache.keys().next().value);
    return record.promise;
  }
  function schedule() {
    if (scheduled || !queue.length) return;
    scheduled = true;
    var run = function () {scheduled = false; pump();};
    if (window.requestIdleCallback) window.requestIdleCallback(run, {timeout: 1200});
    else setTimeout(run, 0);
  }
  function pump() {
    while (active < 2 && queue.length) {
      var job = queue.shift();
      if (!job.root.isConnected) {job.done(); continue;}
      active++;
      (function (current) {
        var finish = function (failed) {active--; current.done(failed); schedule();};
        load(current.url, current.options).then(function () {finish(false);}, function () {finish(true);});
      })(job);
    }
  }
  function galleryOptions(root, button) {
    var main = root.querySelector('[data-lp-life-main]');
    return {srcset: button.dataset.lpLifeSrcset || '', sizes: main && main.sizes || '100vw'};
  }
  function warmProduct(root) {
    if (root.dataset.lpPreloadVersion === '20261020-1') return;
    root.dataset.lpPreloadVersion = '20261020-1';
    var connection = navigator.connection;
    if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType))) {
      root.dataset.lpPreloadState = 'limited';
      return;
    }
    var begin = function () {
      if (!root.isConnected) return;
      var photos = Array.from(root.querySelectorAll('[data-lp-life-photo]'));
      var colors = Array.from(root.querySelectorAll('[data-lp-color]'));
      var chosen = colors.find(function (b) {return b.getAttribute('aria-pressed') === 'true';}) || colors[0];
      var art = root.querySelector('[data-lp-artwork-img]');
      var items = [];
      var add = function (url, options) {if (url) items.push({url: url, options: Object.assign({}, options, {priority: 'low'})});};
      if (art && !art.hidden) add(art.getAttribute('src'));
      if (chosen) add(window.LPPreviewImages.source(chosen));
      colors.slice(0, 3).filter(function (b) {return b !== chosen;}).forEach(function (b) {add(window.LPPreviewImages.source(b));});
      var slow = connection && connection.effectiveType === '3g';
      photos.slice(0, slow ? 2 : photos.length).forEach(function (b) {add(b.dataset.lpLifePhoto, galleryOptions(root, b));});
      if (!slow) colors.slice(3).filter(function (b) {return b !== chosen;}).forEach(function (b) {add(window.LPPreviewImages.source(b));});
      var remaining = items.length;
      var failures = 0;
      root.dataset.lpPreloadTotal = String(remaining);
      root.dataset.lpPreloadCompleted = '0';
      root.dataset.lpPreloadState = remaining ? 'warming' : 'complete';
      var done = function (failed) {
        if (failed) failures++;
        root.dataset.lpPreloadFailed = String(failures);
        remaining--;
        root.dataset.lpPreloadCompleted = String(items.length - remaining);
        if (!remaining) root.dataset.lpPreloadState = failures ? 'partial' : 'complete';
      };
      items.forEach(function (item) {queue.push({root: root, url: item.url, options: item.options, done: done});});
      schedule();
    };
    var hero = root.querySelector('[data-lp-life-main]');
    if (hero && !hero.complete) {
      var started = false;
      var ready = function () {if (!started) {started = true; begin();}};
      hero.addEventListener('load', ready, {once: true});
      hero.addEventListener('error', ready, {once: true});
    } else begin();
  }
  function showGallery(root, button, photos, main, area, caption) {
    if (!main) return;
    var intent = (Number(root.dataset.lpMediaIntent) || 0) + 1;
    root.dataset.lpMediaIntent = String(intent);
    var began = performance.now();
    var options = galleryOptions(root, button);
    root.dataset.lpGalleryState = 'loading';
    main.setAttribute('aria-busy', 'true');
    if (area) area.removeAttribute('aria-busy');
    photos.forEach(function (photo) {photo.setAttribute('aria-pressed', String(photo === button));});
    load(button.dataset.lpLifePhoto, options).then(function () {
      if (!root.isConnected || Number(root.dataset.lpMediaIntent) !== intent) return;
      main.sizes = options.sizes;
      main.srcset = options.srcset;
      main.src = button.dataset.lpLifePhoto;
      main.hidden = false;
      main.removeAttribute('aria-busy');
      if (area) area.hidden = true;
      root.dataset.lpGalleryState = 'ready';
      root.dataset.lpGalleryMs = String(Math.round(performance.now() - began));
      root.dataset.lpGalleryPhoto = button.getAttribute('aria-label') || '';
      if (caption) caption.textContent = 'Lifestyle inspiration · Your selected color and size are kept.';
    }).catch(function () {
      if (Number(root.dataset.lpMediaIntent) !== intent) return;
      root.dataset.lpGalleryState = 'error';
      main.removeAttribute('aria-busy');
    });
  }
  window.LPPreviewImages = {
    source: function (button) {return matchMedia('(max-width: 600px)').matches ? button.dataset.lpImageMobile || button.dataset.lpImage : button.dataset.lpImage;},
    load: load,
    galleryOptions: galleryOptions,
    warmProduct: warmProduct,
    showGallery: showGallery
  };
})();
(function () {
  'use strict';
  function norm(s) {return String(s == null ? '' : s).trim().toLowerCase().replace(/[_\s-]+/g,' ');}
  function start(root) {
    if (root.dataset.lpInitialized === 'yes') return;
    root.dataset.lpInitialized = 'yes';
    var dataTag = root.querySelector('[data-lp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataTag.textContent || '[]'); } catch (e) { variants = []; }
    var ci = parseInt(root.dataset.lpColorIndex, 10), si = parseInt(root.dataset.lpSizeIndex, 10);
    var img = root.querySelector('[data-lp-shirt-img]');
    var allColors = Array.prototype.slice.call(root.querySelectorAll('[data-lp-color]'));
    var allSizes = Array.prototype.slice.call(root.querySelectorAll('[data-lp-size]'));
    var colorLabel = root.querySelector('[data-lp-color-label]');
    var form = root.querySelector('form.lp5000__form');
    var variantInput = root.querySelector('[data-lp-variant-id]');
    var status = root.querySelector('[data-lp-status]');
    var price = root.querySelector('[data-lp-price]');
    var add = root.querySelector('[data-lp-add-button]');
    var countSelect = root.querySelector('[data-lp-name-count]');
    if (!form || !img || !allColors.length || !allSizes.length) return;
    var previewOnly = root.dataset.lpPreviewOnly === 'true';
    var selectedId = variantInput && variantInput.value;
    var initial = variants.find(function (v) {return String(v.id) === String(selectedId);});
    var pickedColor = initial && ci >= 0 && initial.options && initial.options[ci] || 'Black';
    var pickedSize = initial && si >= 0 && initial.options && initial.options[si] || 'M';
    function matching() {
      return variants.find(function (v) {
        return v.options && ci >= 0 && si >= 0 && norm(v.options[ci]) === norm(pickedColor) && norm(v.options[si]) === norm(pickedSize);
      });
    }
    function money(cents) {
      var currency = root.dataset.lpCurrency || 'USD';
      try {return new Intl.NumberFormat('en-US',{style:'currency',currency:currency}).format(cents / 100);}
      catch (e) {return '$' + (cents / 100).toFixed(2);}
    }
    var showPreview = false;
    var imageSequence = 0;
    var imageTarget = '';
    function preview(button) {
      if (!showPreview && root.querySelector('[data-lp-life-main]')) return;
      var source = window.LPPreviewImages.source(button);
      if (source === imageTarget && root.dataset.lpImageState !== 'error') return;
      imageTarget = source;
      var token = ++imageSequence;
      var intent = (Number(root.dataset.lpMediaIntent) || 0) + 1;
      root.dataset.lpMediaIntent = String(intent);
      var began = performance.now();
      var area = root.querySelector('[data-lp-preview-area]');
      var main = root.querySelector('[data-lp-life-main]');
      var caption = root.querySelector('[data-lp-gallery-caption]');
      var art = root.querySelector('[data-lp-artwork-img]');
      if (main) main.removeAttribute('aria-busy');
      root.dataset.lpImageState = 'loading';
      area.setAttribute('aria-busy', 'true');
      if (showPreview && caption) caption.textContent = 'Loading ' + button.dataset.lpColor + ' preview…';
      Promise.all([window.LPPreviewImages.load(source), window.LPPreviewImages.load(art && !art.hidden ? art.getAttribute('src') : '')]).then(function () {
        if (token !== imageSequence || !root.isConnected || Number(root.dataset.lpMediaIntent) !== intent) return;
        img.src = source;
        img.loading = 'eager';
        if (art && !art.hidden) art.loading = 'eager';
        img.alt = button.dataset.lpColor + ' personalized garment color preview';
        root.dataset.lpImageState = 'ready';
        root.dataset.lpImageColor = button.dataset.lpColor;
        root.dataset.lpImageMs = String(Math.round(performance.now() - began));
        area.removeAttribute('aria-busy');
        if (showPreview) {
          if (main) main.hidden = true;
          area.hidden = false;
          root.querySelectorAll('[data-lp-life-photo]').forEach(function (photo) {photo.setAttribute('aria-pressed', 'false');});
          if (caption) caption.textContent = button.dataset.lpColor + ' · Color preview · Example names shown.';
        }
      }).catch(function () {
        if (token !== imageSequence || !root.isConnected || Number(root.dataset.lpMediaIntent) !== intent) return;
        root.dataset.lpImageState = 'error';
        area.removeAttribute('aria-busy');
        if (caption) caption.textContent = 'Could not load ' + button.dataset.lpColor + ' preview. Select the color again to retry.';
      });
    }
    function render() {
      var activeColor = allColors.find(function (b) {return norm(b.dataset.lpColor) === norm(pickedColor);});
      if (!activeColor && colorLabel) colorLabel.textContent = 'Please choose a color';
      if (activeColor) {
        pickedColor = activeColor.dataset.lpColor;
        preview(activeColor);
        colorLabel.textContent = pickedColor;
      }
      allColors.forEach(function (b) {b.setAttribute('aria-pressed',norm(b.dataset.lpColor)===norm(pickedColor)?'true':'false');});
      allSizes.forEach(function (b) {
        var size = b.dataset.lpSize;
        var available = variants.some(function(v){return v.available && ci>=0 && si>=0 && v.options && norm(v.options[ci])===norm(pickedColor) && norm(v.options[si])===norm(size);});
        b.disabled = !available;
        b.setAttribute('aria-pressed',norm(size)===norm(pickedSize)?'true':'false');
        b.setAttribute('aria-label',size + (available?'':' — unavailable'));
      });
      var variant = matching();
      if (variantInput) variantInput.value = variant ? String(variant.id) : '';
      if (variant && price) price.textContent = money(variant.price);
      var safeArtwork = root.dataset.lpArtworkReady === 'true';
      var ready = Boolean(variant && variant.available && safeArtwork && !previewOnly);
      add.disabled = !ready;
      if (previewOnly) {
        status.textContent = root.dataset.lpPreviewMessage;
        status.setAttribute('data-unavailable','');
      } else if (!pickedColor) {
        status.textContent = 'Please choose a color for this garment option.';
        status.setAttribute('data-unavailable','');
      } else if (!pickedSize) {
        status.textContent = 'Please choose an available size for this color.';
        status.setAttribute('data-unavailable','');
      } else if (variant && variant.available && !safeArtwork) {
        status.textContent = 'Add the product-specific transparent artwork before selling this design.';
        status.setAttribute('data-unavailable','');
      } else if (ready) {
        status.textContent = pickedColor + ' / ' + pickedSize + ' is available.';
        status.removeAttribute('data-unavailable');
      } else if (ci < 0 || si < 0) {
        status.textContent = 'Preview only. To enable purchasing, create Shopify variants with Color and Size options.';
        status.setAttribute('data-unavailable','');
      } else {
        status.textContent = 'This color and size are not available yet. Please choose another combination.';
        status.setAttribute('data-unavailable','');
      }
    }
    function colorClick(e) {
      showPreview = true;
      imageTarget = '';
      pickedColor = e.currentTarget.dataset.lpColor;
      var isAvailable = function(size){return variants.some(function(v){return v.available && v.options && ci>=0 && si>=0 && norm(v.options[ci])===norm(pickedColor) && norm(v.options[si])===norm(size);});};
      if (!isAvailable(pickedSize)) {
        pickedSize = '';
      }
      render();
    }
    root.addEventListener('lp:require-color',function(e){pickedColor='';if(e.detail && e.detail.size)pickedSize=e.detail.size;render();});
    allColors.forEach(function(b){
      b.addEventListener('click',colorClick);
      function warm(){window.LPPreviewImages.load(window.LPPreviewImages.source(b)).catch(function(){});var art=root.querySelector('[data-lp-artwork-img]');if(art&&!art.hidden)window.LPPreviewImages.load(art.getAttribute('src')).catch(function(){});}
      b.addEventListener('pointerenter',warm,{once:true});
      b.addEventListener('pointerdown',warm,{once:true,passive:true});
      b.addEventListener('focus',warm,{once:true});
    });
    root.querySelectorAll('[data-lp-life-photo]').forEach(function(photo){photo.addEventListener('click',function(){showPreview=false;});});
    allSizes.forEach(function(b){b.addEventListener('click',function(){pickedSize=b.dataset.lpSize;render();});});
    function updateNameFields(){
      var limit = parseInt(root.dataset.lpNameLimit,10) || 5;
      var count = Math.min(limit, Math.max(1, parseInt(countSelect.value,10) || 1));
      countSelect.value = String(count);
      Array.prototype.slice.call(root.querySelectorAll('[data-lp-name-row]')).forEach(function(row){
        var idx = parseInt(row.dataset.lpNameRow,10);
        var isShown = idx <= count;
        row.hidden = !isShown;
        var input = row.querySelector('input[data-lp-name-input]');
        if (input) {input.disabled = !isShown;input.required = isShown;}
      });
    }
    var nameError = root.querySelector('[data-lp-name-error]');
    var nameInputs = Array.prototype.slice.call(root.querySelectorAll('[data-lp-name-input]'));
    function validateName(input) {
      input.setCustomValidity(input.value && !input.value.trim() ? 'Please enter a pet name, not just spaces.' : '');
    }
    nameInputs.forEach(function(input){
      input.addEventListener('input',function(){
        validateName(input);
        input.removeAttribute('aria-invalid');
        if(nameError){nameError.hidden=true;nameError.textContent='';}
      });
    });
    form.addEventListener('invalid',function(event){
      var input=event.target;
      if(!input.matches('[data-lp-name-input]'))return;
      input.setAttribute('aria-invalid','true');
      if(nameError){
        var label=root.querySelector('label[for="'+input.id+'"]');
        nameError.textContent=(label?label.textContent:'Pet name')+': '+input.validationMessage;
        nameError.hidden=false;
      }
    },true);
    countSelect.addEventListener('change',function(){
      updateNameFields();
      nameInputs.forEach(function(input){validateName(input);input.removeAttribute('aria-invalid');});
      if(nameError){nameError.hidden=true;nameError.textContent='';}
    });
    form.addEventListener('submit',function(e){
      if (root.getAttribute('aria-busy') === 'true' || add.disabled || !variantInput.value) {e.preventDefault();return;}
      updateNameFields();
      var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-lp-name-input]')).filter(function(x){return !x.disabled;});
      inputs.forEach(function(x){x.value=x.value.trim();validateName(x);});
      var seen = inputs.every(function(x){return Boolean(x.value);});
      if (!seen || !form.checkValidity()) {
        e.preventDefault();
        var first = inputs.find(function(x){return !x.value;});
        if (first) {first.focus();first.reportValidity();} else form.reportValidity();
      }
    });
    updateNameFields();
    render();
    window.LPPreviewImages.warmProduct(root);
  }
  function init(){ document.querySelectorAll('[data-lp5000-product]').forEach(start); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();


(function(){function setup(){document.querySelectorAll('[data-lp5000-product]').forEach(function(root){if(root.dataset.lpEnhance)return;root.dataset.lpEnhance='yes';var qualityLinks=Array.from(root.querySelectorAll('[data-lp-quality-link], [data-lp-selection-link]'));if(qualityLinks.length){var qualityKey='levypaw-quality-selection:'+root.dataset.lpFamilyKey;qualityLinks.forEach(function(link){link.addEventListener('click',function(){try{var values=Array.from(root.querySelectorAll('[data-lp-name-input]')).map(function(input){return input.value});var color=root.querySelector('[data-lp-color][aria-pressed="true"]');var size=root.querySelector('[data-lp-size][aria-pressed="true"]');sessionStorage.setItem(qualityKey,JSON.stringify({at:Date.now(),count:root.querySelector('[data-lp-name-count]').value,names:values,color:color?color.dataset.lpColor:'',size:size?size.dataset.lpSize:''}))}catch(e){}})});requestAnimationFrame(function(){try{var saved=JSON.parse(sessionStorage.getItem(qualityKey)||'null');if(!saved||Date.now()-saved.at>1800000)return;var count=root.querySelector('[data-lp-name-count]');count.value=String(Math.min(parseInt(root.dataset.lpNameLimit,10)||5,Math.max(1,parseInt(saved.count,10)||1)));count.dispatchEvent(new Event('change',{bubbles:true}));Array.from(root.querySelectorAll('[data-lp-name-input]')).forEach(function(input,i){input.value=saved.names[i]||''});var chosen=Array.from(root.querySelectorAll('[data-lp-color]')).find(function(b){return b.dataset.lpColor===saved.color});if(chosen)chosen.click();else{root.dispatchEvent(new CustomEvent('lp:require-color',{detail:{size:saved.size}}));var note=root.querySelector('[data-lp-quality-note]');if(note){note.hidden=false;note.textContent='Colors vary by garment. Please choose a color for this option.'}}var size=Array.from(root.querySelectorAll('[data-lp-size]')).find(function(b){return b.dataset.lpSize===saved.size&&!b.disabled});if(size)size.click()}catch(e){}});}var dialog=root.querySelector('.lp-size-dialog');var opener=root.querySelector('[data-lp-size-open]');if(opener&&dialog){opener.addEventListener('click',function(){dialog.showModal()});dialog.querySelector('[data-lp-size-close]').addEventListener('click',function(){dialog.close()});dialog.addEventListener('click',function(e){if(e.target===dialog){var box=dialog.getBoundingClientRect();if(e.clientX<box.left||e.clientX>box.right||e.clientY<box.top||e.clientY>box.bottom)dialog.close()}});var cells=Array.from(dialog.querySelectorAll('td')).filter(function(c){return /^\d+(\.\d+)?$/.test(c.textContent.trim())});cells.forEach(function(c){c.dataset.inches=c.textContent.trim()});dialog.querySelectorAll('[data-lp-unit]').forEach(function(b){b.addEventListener('click',function(){var cm=b.dataset.lpUnit==='cm';dialog.querySelectorAll('th').forEach(function(h){if(/\((in|cm)\)/.test(h.textContent))h.textContent=h.textContent.replace(/\((in|cm)\)/g,cm?'(cm)':'(in)')});cells.forEach(function(c){c.textContent=cm?(Number(c.dataset.inches)*2.54).toFixed(1):c.dataset.inches});dialog.querySelectorAll('[data-lp-unit]').forEach(function(x){x.setAttribute('aria-pressed',String(x===b))});var unitText='Garment measurements in '+(cm?'centimeters':'inches');dialog.querySelector('[data-lp-size-unit-label]').textContent=unitText+'.';var sizeTable=dialog.querySelector('table');if(sizeTable){sizeTable.setAttribute('aria-label',unitText);var sizeCaption=sizeTable.querySelector('caption');if(sizeCaption)sizeCaption.textContent=unitText}})})}var main=root.querySelector('[data-lp-life-main]');var colorArea=root.querySelector('[data-lp-preview-area]');var caption=root.querySelector('[data-lp-gallery-caption]');var photos=Array.from(root.querySelectorAll('[data-lp-life-photo]'));photos.forEach(function(b,i){b.setAttribute('aria-pressed',String(i===0));function warmPhoto(){window.LPPreviewImages.load(b.dataset.lpLifePhoto,window.LPPreviewImages.galleryOptions(root,b)).catch(function(){});}b.addEventListener('pointerenter',warmPhoto,{once:true});b.addEventListener('focus',warmPhoto,{once:true});b.addEventListener('pointerdown',warmPhoto,{once:true,passive:true});b.addEventListener('click',function(){window.LPPreviewImages.showGallery(root,b,photos,main,colorArea,caption);});});root.querySelectorAll('[data-lp-color]').forEach(function(b){b.addEventListener('click',function(){var qualityNote=root.querySelector('[data-lp-quality-note]');if(qualityNote)qualityNote.hidden=true;})});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup)})();
(function () {
  'use strict';
  var cache = new Map();
  var sequence = 0;
  var hasSwitched = false;
  function targetURL(link) {
    var url = new URL(link.href, location.href);
    // Draft previews carry Shopify session context and must use native navigation.
    if (url.origin !== location.origin || !url.pathname.includes('/products/') || url.searchParams.has('preview_key')) return null;
    url.hash = '';
    return url;
  }
  function load(url, root) {
    var request = new URL(url);
    var key = request.href;
    if (!cache.has(key)) {
      var task = fetch(request.href, {credentials: 'same-origin'}).then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-lp5000-product]');
        if (!next || next.dataset.lpFamilyKey !== root.dataset.lpFamilyKey || next.dataset.lpGarmentType !== root.dataset.lpGarmentType || !next.querySelector('[data-lp-variants]')) throw new Error('Product mismatch');
        var warmImages = function () {
          var current = root.querySelector('[data-lp-color][aria-pressed="true"]');
          var chosen = Array.from(next.querySelectorAll('[data-lp-color]')).find(function (button) {return current && button.dataset.lpColor === current.dataset.lpColor;});
          if (!chosen) chosen = next.querySelector('[data-lp-color="Black"]');
          if (chosen) window.LPPreviewImages.load(window.LPPreviewImages.source(chosen)).catch(function () {});
          var art = next.querySelector('[data-lp-artwork-img]');
          if (art && !art.hidden) window.LPPreviewImages.load(art.getAttribute('src')).catch(function () {});
        };
        warmImages();
        return html;
      }).catch(function (error) {cache.delete(key); throw error;});
      cache.set(key, task);
      if (cache.size > 6) cache.delete(cache.keys().next().value);
    }
    return cache.get(key);
  }
  function setup() {
    document.querySelectorAll('[data-lp5000-product]').forEach(function (root) {
      if (root.dataset.lpFastNavigation) return;
      root.dataset.lpFastNavigation = 'yes';
      var links = Array.from(root.querySelectorAll('[data-lp-quality-link]'));
      links.forEach(function (link) {
        var url = targetURL(link);
        if (!url) return;
        function prefetch() {if (url.pathname === '/products_preview') return; if (root.isConnected && !link.hasAttribute('aria-current')) load(url, root).catch(function () {});}
        link.addEventListener('pointerenter', prefetch, {once: true});
        link.addEventListener('focus', prefetch, {once: true});
        link.addEventListener('click', async function (event) {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (link.hasAttribute('aria-current')) return;
          var requestId = ++sequence;
          var started = performance.now();
          var button = root.querySelector('[data-lp-add-button]');
          var disabled = button.disabled;
          root.setAttribute('aria-busy', 'true');
          button.disabled = true;
          try {
            var html = await load(url, root);
            if (requestId !== sequence || !root.isConnected) return;
            var nextDocument = new DOMParser().parseFromString(html, 'text/html');
            var next = nextDocument.querySelector('[data-lp5000-product]');
            if (link.dataset.lpTargetProfile && next.dataset.lpProfile !== link.dataset.lpTargetProfile) throw new Error('Quality mismatch');
            var currentColor = root.querySelector('[data-lp-color][aria-pressed="true"]');
            var nextColor = Array.from(next.querySelectorAll('[data-lp-color]')).find(function (button) {return currentColor && button.dataset.lpColor === currentColor.dataset.lpColor;});
            if (nextColor) {
              var imageStart = performance.now();
              var targetImage = next.querySelector('[data-lp-shirt-img]');
              var targetSource = window.LPPreviewImages.source(nextColor);
              var targetArt = next.querySelector('[data-lp-artwork-img]');
              await Promise.all([window.LPPreviewImages.load(targetSource), window.LPPreviewImages.load(targetArt && !targetArt.hidden ? targetArt.getAttribute('src') : '')]);
              if (requestId !== sequence || !root.isConnected) return;
              targetImage.src = targetSource;
              next.dataset.lpNavigationImageMs = String(Math.round(performance.now() - imageStart));
            }
            root.dispatchEvent(new Event('lp:leaving'));
            root.replaceWith(next);
            var visible = new URL(url);
            visible.hash = 'lp-shirt-options';
            history.pushState({lpQuality: true}, '', visible.href);
            hasSwitched = true;
            document.title = nextDocument.title;
            var metadataSelectors = ['meta[name="description"]', 'meta[name="robots"]', 'meta[property^="og:"]', 'meta[name^="twitter:"]'];
            metadataSelectors.forEach(function (selector) {
              document.head.querySelectorAll(selector).forEach(function (tag) {tag.remove();});
              nextDocument.head.querySelectorAll(selector).forEach(function (tag) {document.head.appendChild(tag.cloneNode(true));});
            });
            var canonical = document.querySelector('link[rel="canonical"]');
            var nextCanonical = nextDocument.querySelector('link[rel="canonical"]');
            if (canonical && nextCanonical) canonical.href = nextCanonical.href;
            document.dispatchEvent(new CustomEvent('shopify:section:load', {detail: {sectionId: next.dataset.lpSectionId}}));
            requestAnimationFrame(function () {
              next.dataset.lpSwitchMs = String(Math.round(performance.now() - started));
              var active = next.querySelector('[data-lp-quality-link][aria-current]');
              if (active) active.focus({preventScroll: true});
            });
          } catch (error) {
            if (requestId === sequence && root.isConnected) {
              root.removeAttribute('aria-busy');
              button.disabled = disabled;
              location.assign(link.href);
            }
          }
        });
      });
      var connection = navigator.connection;
      if (!connection || (!connection.saveData && !/2g/.test(connection.effectiveType))) {
        var pending = links.filter(function (link) {return !link.hasAttribute('aria-current');});
        var warmNext = function () {
          if (!root.isConnected || !pending.length) return;
          var link = pending.shift();
          var url = targetURL(link);
          if (!url || url.pathname === '/products_preview') {scheduleNext(); return;}
          load(url, root).catch(function () {}).then(scheduleNext);
        };
        var scheduleNext = function () {
          if (!root.isConnected || !pending.length) return;
          if ('requestIdleCallback' in window) window.requestIdleCallback(warmNext);
          else setTimeout(warmNext, 200);
        };
        var watchOptions = function () {
          if (!root.isConnected || !('IntersectionObserver' in window)) return;
          var options = root.querySelector('.lp-quality');
          if (!options) return;
          var observer = new IntersectionObserver(function (entries) {
            if (!entries.some(function (entry) {return entry.isIntersecting;})) return;
            observer.disconnect();
            scheduleNext();
          });
          observer.observe(options);
          root.addEventListener('lp:leaving', function () {observer.disconnect();}, {once: true});
        };
        if (document.readyState === 'complete') watchOptions();
        else window.addEventListener('load', watchOptions, {once: true});
      }
    });
  }
  window.addEventListener('popstate', function () {if (hasSwitched) location.reload();});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();






